import { useEffect, useState } from 'react';

// Returns `value` after it has stayed unchanged for `delay` ms. Useful to keep
// a search box from hitting the backend on every keystroke.
const useDebouncedValue = <T>(value: T, delay = 350): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};

export default useDebouncedValue;
